import React from "react";
import { Row, Col, Container, Button, CardImg } from "reactstrap";
import { Link } from "react-router-dom";

import "./academyComponent.css";

const Academy = props => {
  return (
    <div>
      <Container className="pt-4 pb-3 mb-5">
        <Row className="justify-content-center">
          <Col >
            <div className="fc-line ">
              {/* <h1>World-Class Programs For Your Teams.</h1> */}
              <h1 className="all-headers text-center">{props.heading}</h1>
            </div>
          </Col>
        </Row>
        <Row className="pt-lg-5 mt-5 justify-content-center ">
        <Col className="mb-3" xs={{ size: 11 }} lg={{ size: 6}} >
            <Row className="align-self-stretch academy-cards">
             
                <Col xs={{ size: 3 }} className="pr-0 pl-0 ">
                  <CardImg
                    src="img/cloud-icon.svg"
                    className="cloud-icon"
                    top
                  />
                </Col>
                <Col className="text-left pl-3">
                  <div className="position-relative">
                    <h2 className="thin-yellow-line2 academy-h">Cloud Academy</h2>
                  </div>

                  <p>
                    Partnered with a leading expert in Amazon Web Services to bring you
                    a Cloud Academy specifically for your company. From the
                    basics to the integration of cloud into your company and
                    teams, we’ve got you covered.
                  </p>
                  <Link to="/cloud-academy">
                    <Button className="acad-btn">Learn More</Button>
                  </Link>
                </Col>
             
             
            </Row>
          </Col>
          <Col className="mb-3 " xs={{ size: 11 }} lg={{ size: 6}} >
            <Row className="ml-lg-1 align-self-stretch academy-cards">
             
                <Col xs={{ size: 3 }} className="pr-0 pl-0">
                  <CardImg
                    src="img/cybersecurity-icon.svg"
                    className="cyber-icon"
                    top
                  />
                </Col>
                <Col className="text-left pl-3 ">
                  <div className="position-relative">
                    <h2 className="thin-yellow-line2 academy-h">Cyber Security</h2>
                  </div>
                  <p >
                    Partnered with a leading expert in Cyber Security to
                    bring you a program specifically for your company. We are
                    here to help your company, your teams, and your products
                    become secure.
                  </p>
                  <Link to="/cybersecurity-academy">
                    <Button className="acad-btn">Learn More</Button>
                  </Link>
                </Col>
             
            </Row>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Academy;
